import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Virginia = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Virginia Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure of known defects required; no specific form mandated.
        </Text>

        <Text style={styles.listItem}>
          2. Residential Property Disclosure Statement: Required by law.
        </Text>

        <Text style={styles.listItem}>
          3. Virginia sellers are not obligated to disclose material defects
          before selling. Unless otherwise agreed upon, it is the buyer's
          responsibility to conduct a home inspection to examine the condition
          of the property. With that said, sellers must still give buyers the
          necessary disclosure statements, all of which can be accessed below.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Residential Property Disclosure Form
          </Text>{' '}
          – Informs the buyer of any impending building code violations or local
          zoning ordinance issues.
        </Text>

        <Text style={styles.listItem}>
          6.{' '}
          <Text style={styles.underline}>
            Residential Property Disclosure Form
          </Text>{' '}
          – Provides buyers with information regarding flood risk on the
          property.
        </Text>

        <Text style={styles.listItem}>
          7. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Must be provided for homes built before 1978 to disclose lead paint
          history.
        </Text>

        <Text style={styles.listItem}>
          8. <Text style={styles.underline}>Methamphetamine Disclosure</Text> –
          Discloses if the property was previously used for methamphetamine
          production and is yet to be cleaned according to state health
          procedures.
        </Text>

        <Text style={styles.listItem}>
          9. <Text style={styles.underline}>Military Air Zone Disclosure</Text>{' '}
          – Informs buyers if the property is located in a military air zone
          with increased noise levels.
        </Text>

        <Text style={styles.listItem}>
          10.{' '}
          <Text style={styles.underline}>
            Privately Owned Stormwater Management Facility Disclosure
          </Text>{' '}
          – For properties with a private stormwater management facility.
        </Text>

        <Text style={styles.listItem}>
          11.{' '}
          <Text style={styles.underline}>
            Repetitive Risk-Loss Disclosure Statement
          </Text>{' '}
          – Refers to two or more claims of $1,000 or more by the National Flood
          Insurance Program within a 10-year period.
        </Text>

        <Text style={styles.listItem}>
          12.{' '}
          <Text style={styles.underline}>
            Residential Property Disclosure Statement and Acknowledgment
          </Text>{' '}
          – Protects sellers from certain liabilities. Required for most
          residential sales unless exempt.
        </Text>

        <Text style={styles.listItem}>
          13. <Text style={styles.underline}>Septic System Disclosure</Text> –
          Discloses to the buyer if the septic system is faulty and must be
          repaired after the sale.
        </Text>
      </View>
    </View>
  );
};

export default Virginia;
